export default {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    MONTHLY_LAST_DAY: 'MONTHLY_LAST_DAY'
};
